import React from "react";
import "../Assets/WebsiteCss/InteriorPlanning.css";
import interior_living from "../Assets/images/interior_living.jpg";
import interior_design from "../Assets/images/interior_design.jpg";
import {
  FaPalette,
  FaCouch,
  FaLightbulb,
  FaCheckCircle,
  FaHome,
} from "react-icons/fa";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../BaseURL";
import ProjectsPreview from "../Components/ProjectsPreview";

const InteriorPlanning = () => {
  const features = [
    {
      icon: <FaPalette />,
      title: "Color Consultation",
      description:
        "Expert color palettes that create the perfect ambiance and reflect your personality",
    },
    {
      icon: <FaCouch />,
      title: "Space Planning",
      description:
        "Strategic furniture layout and spatial optimization for maximum functionality",
    },
    {
      icon: <FaLightbulb />,
      title: "Lighting Design",
      description:
        "Layered lighting solutions that enhance aesthetics and create mood",
    },
  ];

  const [projects, setProjects] = useState([]);
  const [categoryMap, setCategoryMap] = useState({});

  useEffect(() => {
    const loadData = async () => {
      const projectRes = await axios.get(`${BASE_URL}/api/projects`);
      const categoryRes = await axios.get(
        `${BASE_URL}/api/category/get-category`,
      );
      const map = {};
      categoryRes.data.data.forEach((c) => {
        map[c._id] = c.categoryName;
      });

      const allProjects = projectRes.data.data;

      // Latest 3 projects
      setProjects(allProjects.slice(-3).reverse());
      setCategoryMap(map);
    };

    loadData();
  }, []);

  return (
    <div className="ip-page">
      {/* HERO SECTION */}
      <section className="ip-hero">
        <div className="ip-hero-overlay" />
        <div className="ip-hero-content">
          <div className="ip-hero-badge">
            <FaHome /> Our Services
          </div>
          <h1 className="ip-hero-title">
            Interior Planning
            <span className="ip-highlight">&amp; Design</span>
          </h1>
          <p className="ip-hero-subtitle">
            Transform your interiors into stunning, functional spaces that
            reflect your unique style. From concept to completion, we craft
            personalized designs that bring your vision to life.
          </p>
          <div className="ip-hero-stats">
            <div className="ip-stat-item">
              <span className="ip-stat-number">400+</span>
              <span className="ip-stat-label">Interiors Designed</span>
            </div>
            <div className="ip-stat-divider" />
            <div className="ip-stat-item">
              <span className="ip-stat-number">98%</span>
              <span className="ip-stat-label">Client Satisfaction</span>
            </div>
            <div className="ip-stat-divider" />
            <div className="ip-stat-item">
              <span className="ip-stat-number">12+</span>
              <span className="ip-stat-label">Years Experience</span>
            </div>
          </div>
        </div>
      </section>

      {/* SHOWCASE SECTION */}
      <section className="ip-showcase-section">
        <div className="ip-showcase-grid">
          <div className="ip-showcase-item">
            <div className="ip-showcase-image-wrapper">
              <img
                src={interior_living}
                alt="Modern Living Room Interior Design"
                className="ip-showcase-image"
              />
              <div className="ip-image-badge">Living Spaces</div>
            </div>
            <div className="ip-showcase-content">
              <h3>Contemporary Living Spaces</h3>
              <p>
                Create inviting living areas that blend comfort with style. Our
                designs focus on creating warm, functional spaces where your
                family can gather, relax, and make lasting memories.
              </p>
              <ul className="ip-showcase-features">
                <li>
                  <FaCheckCircle /> Custom furniture selection
                </li>
                <li>
                  <FaCheckCircle /> Personalized color schemes
                </li>
                <li>
                  <FaCheckCircle /> Ambient lighting solutions
                </li>
                <li>
                  <FaCheckCircle /> Decor and accessory curation
                </li>
              </ul>
            </div>
          </div>

          <div className="ip-showcase-item ip-reverse">
            <div className="ip-showcase-image-wrapper">
              <img
                src={interior_design}
                alt="Interior Design Planning Process"
                className="ip-showcase-image"
              />
              <div className="ip-image-badge">Design Process</div>
            </div>
            <div className="ip-showcase-content">
              <h3>Tailored Design Solutions</h3>
              <p>
                From concept sketches to final installation, we handle every
                detail of your interior transformation. Our collaborative
                approach ensures your space perfectly reflects your lifestyle
                and aesthetic preferences.
              </p>
              <ul className="ip-showcase-features">
                <li>
                  <FaCheckCircle /> Mood boards and style concepts
                </li>
                <li>
                  <FaCheckCircle /> Material and finish selection
                </li>
                <li>
                  <FaCheckCircle /> 3D visualization renders
                </li>
                <li>
                  <FaCheckCircle /> Project management and installation
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES GRID */}
      <section className="ip-features-section">
        <div className="ip-section-header">
          <h2 className="ip-section-title">Why Choose Our Interior Services</h2>
        </div>

        <div className="ip-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="ip-feature-card">
              <div className="ip-feature-icon">{feature.icon}</div>
              <h3 className="ip-feature-title">{feature.title}</h3>
              <p className="ip-feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* RELATED PROJECTS */}
      <section className="ip-related-projects">
        <div className="ip-section-header">
          <h2 className="ip-section-title">Some of our recent projects</h2>
        </div>

        <div className="ip-projects-wrapper">
          <ProjectsPreview projects={projects} categoryMap={categoryMap} />
        </div>
      </section>
    </div>
  );
};

export default InteriorPlanning;
